import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { List, ListItemButton, ListItemIcon, ListItemText, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

// assets
import { EditOutlined, ProfileOutlined, DeleteOutlined, LogoutOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons';
import { deleteUser } from 'services/apiService';
import { showAppAlert } from 'store/reducers/appreducer';
import useToken from 'services/useToken';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = ({ handleLogout }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const token = useToken();
  const { organizationName } = useParams()
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);

  // Get partner session flag
  const isPartnerSession = sessionStorage.getItem('is_partner_session') === 'true';

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const handleDeleteUser = async () => {
    try {
      await deleteUser(token.token)
        .then((res) => {
          console.log('res', res);
          if (res && res.status === 200) {
            const message = res.message || 'User account deleted successfully!';
            dispatch(showAppAlert({ show: true, alertType: 'success', alertMessage: message }));
            handleLogout();
          }
        })
        .catch((e) => {
          console.log('error occured', e);
          const message = e.message || 'An error occurred during deleting user account!';
          dispatch(showAppAlert({ show: true, alertType: 'error', alertMessage: message }));
        });
    } catch (error) {
        console.log('Something went wrong!', error);
    }
  };

  const handleNavigate = (path) => {
    navigate(`/${organizationName}/${path}`);
  }

  return (
    <>
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
        <ListItemButton
          onClick={() => {
            if (!isPartnerSession) handleNavigate('change-password');
          }}
          disabled={isPartnerSession}
        >
          <ListItemIcon>
            <EditOutlined />
          </ListItemIcon>
          <ListItemText primary="Change Password" />
        </ListItemButton>
        <ListItemButton
          selected={selectedIndex === 1}
          onClick={(event) => {
            if (!isPartnerSession) {
              handleListItemClick(event, 1);
              handleDialogOpen();
            }
          }}
          disabled={isPartnerSession}
        >
          <ListItemIcon>
            <DeleteOutlined />
          </ListItemIcon>
          <ListItemText primary="Delete Account" />
        </ListItemButton>

        {/* <ListItemButton selected={selectedIndex === 3} onClick={(event) => handleListItemClick(event, 3)}>
        <ListItemIcon>
          <ProfileOutlined />
        </ListItemIcon>
        <ListItemText primary="Social Profile" />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 4} onClick={(event) => handleListItemClick(event, 4)}>
        <ListItemIcon>
          <WalletOutlined />
        </ListItemIcon>
        <ListItemText primary="Billing" />
      </ListItemButton> */}
        <ListItemButton
          selected={selectedIndex === 2}
          onClick={isPartnerSession ? undefined : handleLogout}
          disabled={isPartnerSession}
        >
          <ListItemIcon>
            <LogoutOutlined />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </List>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Delete'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Are you sure you want to delete your account? Confirming this action will log you out immediately!</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteUser} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func
};

export default ProfileTab;
